import { observer } from "mobx-react";
import React from "react";
import "./MainAreaAccordion.css";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";

type Props = {
	headline: any;
};



@observer
class MainAreaAccordion extends React.Component<Props> {


	contentElement: HTMLDivElement | null = null

	componentDidMount() {
		window.addEventListener("scroll", () => { this.handleScroll() });
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", () => { this.handleScroll() });
	}

	handleScroll() {
		if (window.scrollY >= 64) {
			generalConfigurationStore.isPreviewSticky = true;
		} else {
			generalConfigurationStore.isPreviewSticky = false;
		}
		if (this.contentElement) {
			generalConfigurationStore.previewContentHeight = this.contentElement.clientHeight;
		}
	};

	componentDidUpdate() {
		generalConfigurationStore.previewContentHeight = this.contentElement?.clientHeight || generalConfigurationStore.previewContentHeight;
	}


	render() {

		return (
			<div ref={(element) => this.contentElement = element} className={`main-area-accordion ${generalConfigurationStore.isPreviewOpen ? "open" : ""} ${generalConfigurationStore.isPreviewSticky ? "is-sticky" : ""}`}>
				{this.props.children}
				<div className="main-area-accordion-header">
					<button
						className="btn-step"
						onClick={() => {
							generalConfigurationStore.isPreviewOpen = !generalConfigurationStore.isPreviewOpen
							generalConfigurationStore.previewContentHeight = this.contentElement?.clientHeight || generalConfigurationStore.previewContentHeight;
						}}
					>
						{this.props.headline}
					</button>
				</div>
			</div>
		);
	}
}

export default MainAreaAccordion;
